"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var URL_BASE_SEGMENT = 'api';
var keys = {
    chan_: 'channels',
    bran_: 'brands',
    seas_: 'seasons',
    epis_: 'episodes',
    asse_: 'assets',
    plac_: 'placeholders',
    coll_: 'sets',
};
var urlReg = new RegExp("^/" + URL_BASE_SEGMENT + "/(?:" + Object.values(keys).join('|') + ")/([^/]+?)/$");
function urlToId(url) {
    var matches = urlReg.exec(url);
    if (!matches) {
        return url;
    }
    return matches[1];
}
exports.urlToId = urlToId;
function idToUrl(id) {
    var prefix = id.slice(0, 5);
    var key = keys[prefix];
    if (!key) {
        return id;
    }
    return "/" + URL_BASE_SEGMENT + "/" + key + "/" + id + "/";
}
exports.idToUrl = idToUrl;
//# sourceMappingURL=UrlIdMapper.js.map